import React from 'react'

import { withRouter } from 'react-router-dom';

import { ModalUploadFirmware } from 'modals';

import { Section, Table, InfosBar } from 'components';
import { Container, Button, Label, Dropdown, Icon } from 'semantic-ui-react'

import { EnumChannel } from 'enums';

import { BreadcrumbHelper, Typeof } from 'utils';

import compareVersion from 'compare-versions';

import './style.css';

const FIRMWARES_PER_PAGE = 10;

const NO_FILTER = "none";

class FirmwareListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      firmwares: props.firmwares,
      firmwareCriteria: '',
      channelFilter: NO_FILTER,
      showFirmwareCreateModal: false
    };

    this.handleFirmwareSearch = this.handleFirmwareSearch.bind(this);
    this.handleFilter = this.handleFilter.bind(this);

    this.toggleFirmwareCreateModal      = this.toggleFirmwareCreateModal.bind(this);
    this.handleFirmwareCreateModalClose = this.handleFirmwareCreateModalClose.bind(this);

    this.handleFirmwareSelect = this.handleFirmwareSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Micrologiciels capteur', '/firmwares');

    const params = new Map(this.props.location.search.slice(1).split('&').map(kv => kv.split('=')))

    if(params.has('channel')) {

      let channel = params.get('channel').trim();

      this.setState({
        channelFilter: channel
      });

      BreadcrumbHelper.push(EnumChannel.name(channel));
    }

    BreadcrumbHelper.flush();
  }

  handleFirmwareSearch(criteria) {

    this.setState({
      firmwareCriteria: criteria
    });
  }

  handleFirmwareSelect(firmware) {

    //Navigate to firmware page
    this.props.history.push(`/firmwares/${firmware.channel}/${firmware.version}`);
  }

  handleFilter(event, { value }) {

    this.setState({
      channelFilter: value
    });
  }

  toggleFirmwareCreateModal() {
    this.setState({
      showFirmwareCreateModal: !this.state.showFirmwareCreateModal
    });
  }

  handleFirmwareCreateModalClose(firmware) {

    if (Typeof.object(firmware)) {

      this.state.firmwares.push(firmware);
      this.forceUpdate();
    }

    this.toggleFirmwareCreateModal();
  }

  render() {

    let { firmwares } = this.props;

    let columns = [
      {
        id: 'id',
        header: 'Numéro de version',
        value: (firmware) => firmware.version,
        render: (firmware) => {
          return (
            <span>

              {/* Latest */}
              {firmware === this.getLatestFirmwareOnChannel(firmwares, firmware.channel) &&
                <Icon name="star" />
              }

              {/* Version */}
              {firmware.version}

            </span>
          );
        },
        sort: (a, b) => {
          return compareVersion(a.version, b.version);
        }
      },
      {
        id: 'channel',
        header: 'Canal',
        value: (firmware) => EnumChannel.name(firmware.channel),
        render: (firmware) => {
          return (
            <Label color={EnumChannel.color(firmware.channel)}>{EnumChannel.name(firmware.channel)}</Label>
          )
        },
        fit: true,
      },
      {
        id: 'app_version',
        header: "Version minimale de l'application",
        value: (firmware) => firmware.minimum_app_version,
        render: (firmware) => {
          return firmware.minimum_app_version
        },
        fit: true,
        getHeaderClass: () => "wrap"
      },
      {
        id: 'available',
        header: 'Disponible',
        value: (firmware) => firmware.available,
        render: (firmware, available) => {
          return (
            <Icon name={available ? "checkmark" : "times"} color={available ? "green" : "red"} />
          )
        },
        fit: true,
        sort: (a, b) => {
          return a.state - b.state;
        }
      }
    ];

    let channelsFilter = [{
      key: NO_FILTER,
      value: NO_FILTER,
      text: "Tous"
    }];

    EnumChannel.values.forEach((channel) => {
      channelsFilter.push({
        key: channel,
        value: channel,
        text: EnumChannel.name(channel)
      });
    });

    if(this.state.channelFilter !== NO_FILTER) {

      columns.splice(1, 1);

      firmwares = firmwares.filter((firmware) => {
        return firmware.channel === this.state.channelFilter
      });
    }

    return (
      <React.Fragment>

        <Container id="firmwares-list">

          {/* Firmwares */}
          <Section title="Liste des micrologiciels" onSearch={this.handleFirmwareSearch} criteria={this.state.firmwareCriteria} actions={[

            // Add firmware
            <Button icon="upload" content="Téléverser" onClick={this.toggleFirmwareCreateModal} />
          ]}>

            {firmwares.length > 0 ? (

              <React.Fragment>

                {/* Number of available firmwares */}
                <InfosBar mode="column">
                  <span>{firmwares.length > 1 ? `${firmwares.length} micrologiciels disponibles` : '1 micrologiciel disponible'}</span>

                  {/* Channel filter */}
                  <Dropdown icon="filter" value={this.state.channelFilter} options={channelsFilter} onChange={this.handleFilter} direction='left' key={0} />
                </InfosBar>

                {/* Firmwares list */}
                <Table attached columns={columns}
                  criteria={this.state.firmwareCriteria}
                  items={firmwares}
                  itemsPerPage={FIRMWARES_PER_PAGE}
                  onSelect={this.handleFirmwareSelect}
                  messageEmpty="Aucune micrologiciel ne correspond à votre recherche"
                  sort="id"
                  direction="descending"
                  getRowClass={(firmware) => {
                    return !firmware.available ? "not-available" : undefined
                  }}
                />

              </React.Fragment>

            ) : (

              // No firmware available
              <InfosBar mode="row">
                <span>Aucune micrologiciel disponible</span>
              </InfosBar>

            )}


          </Section>

        </Container>

        {/* Modal create firmware */}
        {this.state.showFirmwareCreateModal &&
          <ModalUploadFirmware onClose={this.handleFirmwareCreateModalClose} />
        }

      </React.Fragment>

    );
  }

  getLatestFirmwareOnChannel(firmwares, channel) {

    if(Typeof.array(firmwares) && firmwares.length > 0) {

      let filtered = firmwares.filter((firmware) => firmware.available && firmware.channel === channel).sort((a, b) => compareVersion(b.version, a.version));

      return filtered.length > 0 ? filtered[0] : undefined;
    }

    return undefined;
  }
}

export default withRouter(FirmwareListScene);
